module.exports = __webpack_public_path__ + "img/arrow-right.c42347f3.svg";